import { render } from "./upload-documents.vue?vue&type=template&id=599a7001&scoped=true"
import script from "./upload-documents.vue?vue&type=script&lang=js"
export * from "./upload-documents.vue?vue&type=script&lang=js"

import "./upload-documents.vue?vue&type=style&index=0&id=599a7001&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-599a7001"

export default script